export const fontStyle = {
  fontFamily: '\"Noto Sans JP\", sans-serif',
  fontWeight: 'light'
}